import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const SocialProofBlockLinks = ({
  key,
  heading=null,
  subText=null,
  backgroundColor="white",
  grayscale=true,
  logos=null,
  buttons=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <div className={ `our-awards proofs-with-links bg-${backgroundColor}` }>
      <div className="container">
        <div className="row jcc acc">
          <div className="col-sm-12 col-md-6">
            {heading &&
              <h2 className="content-title text-center mb4">{ htmlDecode(heading) }</h2>
            }
            {subText &&
              <div className="section-content text-center mb4" dangerouslySetInnerHTML={{ __html: subText }} />
            }
          </div>
        </div>
        <div className="col-12 col-md-14 row jcc logo-block-wrap">
          {logos && logos.map((logoObj) => (
            <div className="col-12 col-md-6 col-lg-3 jcc df">
              <div className="logo-block">
                <div className="icon-wrap">
                  {logoObj.link &&
                    <Link href={ logoObj.link }>
                      {logoObj.logo?.formats?.medium &&
                        <img className={ `img-responsive ${grayscale ? "grayscale" : ""}` } alt={ logoObj?.alternativeText } src={logoObj.logo.formats.medium.url.includes(cdnUrl) ? logoObj.logo.formats.medium.url : cdnUrl + logoObj.logo.formats.medium.url} />
                      }
                      {(!logoObj.logo?.formats?.medium && logoObj.logo) &&
                        <img className={ `img-responsive ${grayscale ? "grayscale" : ""}` } alt={ logoObj?.alternativeText } src={logoObj.logo.url.includes(cdnUrl) ? logoObj.logo.url : cdnUrl + logoObj.logo.url} />
                      }
                    </Link>
                  }
                  {!logoObj.link &&
                    <>
                      {logoObj.logo?.formats?.medium &&
                        <img className={ `img-responsive ${grayscale ? "grayscale" : ""}` } alt={ logoObj?.alternativeText } src={logoObj.logo.formats.medium.url.includes(cdnUrl) ? logoObj.logo.formats.medium.url : cdnUrl + logoObj.logo.formats.medium.url} />
                      }
                      {(!logoObj.logo?.formats?.medium && logoObj.logo) &&
                        <img className={ `img-responsive ${grayscale ? "grayscale" : ""}` } alt={ logoObj?.alternativeText } src={logoObj.logo.url.includes(cdnUrl) ? logoObj.logo.url : cdnUrl + logoObj.logo.url} />
                      }
                    </>
                  }
                </div>
                {(logoObj.title || logoObj.text) &&
                  <div className="text-wrap">
                    {logoObj.title &&
                      <>
                        {logoObj.link &&
                          <Link href={ logoObj.link }>
                            <h3 className="teaser-subhead text-center">{ htmlDecode(logoObj.title) }</h3>
                          </Link>
                        }
                        {!logoObj.link &&
                          <h3 className="teaser-subhead text-center">{ htmlDecode(logoObj.title) }</h3>
                        }
                      </>
                    }
                    {logoObj.text &&
                      <p className="copy text-center mb0" dangerouslySetInnerHTML={{ __html: logoObj.text }} />
                    }
                  </div>
                }
              </div>
            </div>
          ))}
        </div>
        <div className="row jcc">
          <div className="col text-center">
            {buttons && buttons.map((button) => (
              <Link href={ button.link } className="link mt3 mh1">{ button.text }</Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SocialProofBlockLinks
